import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Card } from 'react-bootstrap';
import { formatCurrency } from 'Helpers/UiHelper';

const CnxModSummaryCards = ({ cnxMod }) => {
  const {
    totalCount = 0,
    cancelledCount = 0,
    modifiedCount = 0,
    totalCost = 0,
    cancellationFees = 0,
    modificationFees = 0,
  } = cnxMod || {};

  return (
    <Row className="g-2 mb-3">
      <Col xs={6} md={4} lg={2}>
        <Card className="h-100 shadow-sm border-0">
          <Card.Body className="text-center py-3">
            <div style={{ fontSize: '1.5rem', fontWeight: 700, color: '#e74a3b' }}>{totalCount}</div>
            <div
              style={{
                fontSize: '0.7rem',
                fontWeight: 700,
                textTransform: 'uppercase',
                color: '#888',
                letterSpacing: '0.5px',
                marginTop: '2px',
              }}
            >
              Total CNX/MOD
            </div>
          </Card.Body>
        </Card>
      </Col>
      <Col xs={6} md={4} lg={2}>
        <Card className="h-100 shadow-sm border-0">
          <Card.Body className="text-center py-3">
            <div style={{ fontSize: '1.5rem', fontWeight: 700, color: '#e74a3b' }}>{cancelledCount}</div>
            <div
              style={{
                fontSize: '0.7rem',
                fontWeight: 700,
                textTransform: 'uppercase',
                color: '#888',
                letterSpacing: '0.5px',
                marginTop: '2px',
              }}
            >
              Cancelled
            </div>
          </Card.Body>
        </Card>
      </Col>
      <Col xs={6} md={4} lg={2}>
        <Card className="h-100 shadow-sm border-0">
          <Card.Body className="text-center py-3">
            <div style={{ fontSize: '1.5rem', fontWeight: 700, color: '#f6c23e' }}>{modifiedCount}</div>
            <div
              style={{
                fontSize: '0.7rem',
                fontWeight: 700,
                textTransform: 'uppercase',
                color: '#888',
                letterSpacing: '0.5px',
                marginTop: '2px',
              }}
            >
              Modified
            </div>
          </Card.Body>
        </Card>
      </Col>
      <Col xs={6} md={4} lg={2}>
        <Card className="h-100 shadow-sm border-0">
          <Card.Body className="text-center py-3">
            <div style={{ fontSize: '1.5rem', fontWeight: 700, color: '#4e73df' }}>{formatCurrency(totalCost)}</div>
            <div
              style={{
                fontSize: '0.7rem',
                fontWeight: 700,
                textTransform: 'uppercase',
                color: '#888',
                letterSpacing: '0.5px',
                marginTop: '2px',
              }}
            >
              Total Cost
            </div>
          </Card.Body>
        </Card>
      </Col>
      <Col xs={6} md={4} lg={2}>
        <Card className="h-100 shadow-sm border-0">
          <Card.Body className="text-center py-3">
            <div style={{ fontSize: '1.5rem', fontWeight: 700, color: '#e74a3b' }}>
              {formatCurrency(cancellationFees)}
            </div>
            <div
              style={{
                fontSize: '0.7rem',
                fontWeight: 700,
                textTransform: 'uppercase',
                color: '#888',
                letterSpacing: '0.5px',
                marginTop: '2px',
              }}
            >
              Cancellation Fees
            </div>
          </Card.Body>
        </Card>
      </Col>
      <Col xs={6} md={4} lg={2}>
        <Card className="h-100 shadow-sm border-0">
          <Card.Body className="text-center py-3">
            <div style={{ fontSize: '1.5rem', fontWeight: 700, color: '#f6c23e' }}>
              {formatCurrency(modificationFees)}
            </div>
            <div
              style={{
                fontSize: '0.7rem',
                fontWeight: 700,
                textTransform: 'uppercase',
                color: '#888',
                letterSpacing: '0.5px',
                marginTop: '2px',
              }}
            >
              Modification Fees
            </div>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
};

CnxModSummaryCards.propTypes = {
  cnxMod: PropTypes.shape({
    totalCount: PropTypes.number,
    cancelledCount: PropTypes.number,
    modifiedCount: PropTypes.number,
    totalCost: PropTypes.number,
    cancellationFees: PropTypes.number,
    modificationFees: PropTypes.number,
  }).isRequired,
};

export default CnxModSummaryCards;
